module.exports = {
	url: '/',
	template: require('raw!templates/home/home-view.html'),
	controller: HomeController,
	controllerAs: 'homeCtrl',
};

function HomeController($scope, $state, store, $window, contentful, $http) {
	var vm = this;
  $window.scrollTo(0, 0);
	contentful.entries('content_type=homePage').then(function(res) {
		// console.log('home page contentful data',res);
		$scope.home = res.data.items[0];
		var seoData = res.data.items[0];
		if (seoData.fields.seoPageTitle) {
			document.title = seoData.fields.seoPageTitle;
		}
		if (seoData.fields.seoPageDescription) {
			var meta = document.getElementsByTagName("meta");
			for (var i = 0; i < meta.length; i++) {
				if (meta[i].name.toLowerCase() === "description") {
					meta[i].content = seoData.fields.seoPageDescription;
				}
			}
		}
	});

	$window.sr = ScrollReveal({ reset: false });
	sr.reveal('.home-load', { duration: 1000 });
	sr.reveal('.home-test', { rotate: { x: 0, y: 0, z: 100 },});

	$('.tri-up a').click(() => {
		$('html, body').animate({
			scrollTop: window.pageYOffset + $(window).height()
		}, 300);
		return false;
	});
	function myFunction(x) {
	x.classList.toggle("change");
}
}



// WEBPACK FOOTER //
// ./components/templates/home/home-controller.js